module.exports = __webpack_public_path__ + "static/press-founders-92fefa6a7b1b9e124de2b64a97dea394.png";